module.exports = require("core-js/library/fn/number/max-safe-integer");